import MailIcon from "@mui/icons-material/Mail";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button, Toolbar, Typography } from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import { RecommendationContext } from "../../context/RecommendationContext";
import useApi from "../../service/api.service";
import { customDateConvert } from "./Utils/Utils";
import CustomSkeleton from "./CustomSkeleton";

const iconStyle = { ml: 1, fontSize: "18px", color: "#9F9F9F" };
function RecommendationPanel({ type, id }) {
  const [selectedButton, setSelectedButton] = useState("Alerts");
  const [loading, setLoading] = useState(false);
  const API = useApi();

  const buttonStyle = (buttonName) => ({
    margin: "5px 10px",
    textTransform: "capitalize",
    color: "#404040",
    fontSize: "12px",
    padding: "3px 15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "4px",
    cursor: "default",
    position: "sticky",
    top: 0,
    zIndex: 1000,
    backgroundColor: "white",
  });

  const mailIconStyle = { mr: 1, fontSize: "16px", color: "black" };
  const dateTextStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "13px",
  };

  const [recommendedData, setRecommendedData] = useState([]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await API.fetchRecommendedData();
      setLoading(false);
      setRecommendedData(response.data);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      {loading ? (
        <CustomSkeleton height="249px" />
      ) : (
        <>
          <div style={buttonStyle("Alerts")}>
            <StarIcon sx={{ fontSize: "18px", color: "#34A853" }} />
            Recommendations
          </div>
          <div
            style={{
              backgroundColor: "white",
              overflow: "auto",
              borderTop: "1px solid #E4E4E4",
              flexGrow: 1,
            }}
          >
            {recommendedData.length > 0 ? (
              recommendedData?.map((data, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      borderBottom: "1px solid #E4E4E4",
                      // minHeight: "75px",
                      padding: "12px",
                      font: "Montserrat, sans-serif",
                      fontSize: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <div>
                        {/* {moment(alert?.createdTime)?.format("DD/MM/YYYY HH:mm:ss")} */}
                        {customDateConvert(data?.date, "MM/DD/YYYY")}
                      </div>
                      <div>
                        {/* <Link to={"/alerts"}> */}
                        {/* <OpenInNewIcon sx={iconStyle} /> */}
                        {/* </Link> */}
                      </div>
                    </div>
                    <div>
                      Optimize production by adjusting {data.factorName} as it
                      was the most frequent highest contributing factor on{" "}
                      {customDateConvert(data?.date, "MM/DD/YYYY")}.
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  width: "100%",
                  borderTop: "1px solid #E4E4E4",
                  // height: "75px",
                  padding: "12px",
                  fontSize: "12px",
                  font: "Montserrat, sans-serif",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    alignItems: "center",
                    color: "red",
                  }}
                >
                  No Recommendations
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default RecommendationPanel;
